import { allBrandsData } from "./data";

function checkBrandExists(brandName) {
  console.log(brandName);
  const foundBrand = allBrandsData.find((brand) => brand?.name?.toLowerCase() === brandName?.toLowerCase());
  console.log(foundBrand);
  return foundBrand ? foundBrand.name : null;
}
export default checkBrandExists;
